import { Container, ContainerProps, VStack } from '@chakra-ui/react'
import React, { FC } from 'react'

/**
 * Elevated container.
 *
 * Must be placed within a parent with `display: flex` in order to grow till
 * the bottom.
 */
export const ElevatedContainer: FC<ContainerProps> = ({
  children,
  ...rest
}) => (
  <Container
    data-testid="elevated-container"
    flexGrow={1}
    variant="elevated"
    {...rest}>
    <VStack spacing="1rem">{children}</VStack>
  </Container>
)
